<!-- SDB Lamp Zone,Plant, Local setting -->
<template>
  <div class="pl-1">
      <!-- Details input config on Zone, Plant, Local -->
      
      <!-- attivo su gruppo -->
      <b-row>
      <b-col sm="5" class="pt-2" v-if="currentSetting.local!=true && currentSetting.allZone==false && currentSetting.allPlant==false && currentGroup!=0">
        {{ $t("details_lamp.input_config") }} : </b-col>
      <b-col sm="7" class="pt-2" v-if="currentSetting.local!=true && currentSetting.allZone==false && currentSetting.allPlant==false && currentGroup!=0">
          {{$t("details_lamp.input_group") + " " + currentGroup }} </b-col>
      </b-row>
      
      <!-- attivo su zona -->    
      <b-row>
      <b-col sm="5" class="pt-2" v-if="currentSetting.local!=true && currentSetting.allPlant==false && (currentGroup==0 || currentSetting.allZone==true)">
            {{ $t("details_lamp.input_config") }} : </b-col>
          <b-col sm="7" class="pt-2" v-if="currentSetting.local!=true && currentSetting.allPlant==false && (currentGroup==0 || currentSetting.allZone==true)">
            {{ $t("details_lamp.input_all_zone") }}</b-col>
      </b-row>       
      
      <!-- attivo su impianto -->    
      <b-row>
        <b-col sm="5" class="pt-2" v-if="currentSetting.allPlant==true">
                   {{ $t("details_lamp.input_config") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentSetting.allPlant==true">
                  {{ $t("details_lamp.input_all_plant") }}</b-col>
      </b-row>

      <!-- attivo localmente -->    
      <b-row>
        <b-col sm="5" class="pt-2" v-if="currentSetting.local==true">
                   {{ $t("details_lamp.input_config") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentSetting.local==true">
                        {{ $t("details_lamp.input_local") }}</b-col>
      </b-row>
  
  </div>
</template>

<script>

export default {
  name: "LampBleZoneLocalPlant",
  props: {
    currentSetting: null,
    currentGroup: null
  },

  
  data()
  {
    return {

    };
  },

}
</script>
